import React from 'react';
// import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import jwt_decode from 'jwt-decode';
import setAuthToken from './setAuthToken';
import { setCurrentUser, logoutUser } from './actions/authentication';
import { setCurrentOrg } from './actions/authentication';

import "rsuite/dist/rsuite.min.css";
import './App.scss';

import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Topbar from './components/Topbar';
import Register from './components/Register';
import Login from './components/Login';
import Home from './components/Home';
import Users from './components/Users';
import Organizations from './components/Organizations';
import Orders from './components/Orders';
import Clients from './components/Clients';
import WorkCalendar from './components/Calendar';
import WorkMap from './components/Map';
import LoadToStore from './components/AppLoadToStore';

// import { subscribeUser } from './subscription';


if(localStorage.jwtToken) {
  setAuthToken(localStorage.jwtToken);
  const decoded = jwt_decode(localStorage.jwtToken);
  store.dispatch(setCurrentUser(decoded));

  const currentTime = Date.now() / 1000;
  if(decoded.exp < currentTime) {
    store.dispatch(logoutUser());
    window.location.href = '/login'
  }
}

// store.subscribe(() => {
//     const newState = store.getState();
//     console.log('newState');
//     console.log(newState);
// });

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoggedIn: false,
    };
  }
  componentDidMount() {
    let state = store.getState(); 
    // console.log('store.state', state);
    const currentorg = state.orgcurrent.list;
    if(localStorage.jwtToken) {
      const decoded = jwt_decode(localStorage.jwtToken);
      this.setState({isLoggedIn: true});
    }
  }

  componentDidUpdate(prevProps) {
    // console.log('app.js this.props', this.props);
    // console.log();
    // if(prevProps.auth.isAuthenticated !== this.props.auth.isAuthenticated) {
    //     this.setState({isLoggedIn: true});
    // }
  }


  render() {
    let isLoggedIn = this.state.isLoggedIn;
    // console.log('app.js this.state.isLoggedIn', this.state.isLoggedIn);

    return (
      <Provider store = { store }>
        <Router>
          <LoadToStore />
          <div className="app">
            <Navbar />
              <div className="container">
                <Topbar />
                <Routes>
                    {/* <Route path="/orders" element={isLoggedIn ? <Orders/> : <Navigate to='/login'/>} /> */}

                    <Route element={<ProtectedRoute />}>
                        <Route path="/" element={<Home/>} />
                        <Route path="/organizations" element={<Organizations/>} />
                        <Route path="/orders" element={<Orders/>} />
                        <Route path="/clients" element={<Clients/>} />
                        <Route path="/users" element={<Users/>} />
                        <Route path="/calendar" element={<WorkCalendar/>} />
                        <Route path="/map" element={<WorkMap/>} />
                    {/* Handle other routes */}
                    </Route>
                    <Route path="/register" element={<Register/>} />
                    <Route path="/login" element={<Login/>} />
                </Routes>
              </div>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
